export enum VerificatoinLinkType {
  EmailVerification = 'email-verification',
  EmailChange = 'email-change',
  PasswordReset = 'password-reset',
}
